export default __webpack_public_path__ + "static/media/absolute_volume_slider.b24f004c.PNG";